var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#09041C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7491 20.4594C33.6546 19.6249 32.9118 18.8248 32.1346 18.7176C27.3957 18.0941 22.6035 18.0941 17.866 18.7176C17.0882 18.8245 16.3454 19.6249 16.2509 20.4594C15.9164 23.5177 15.9164 26.4829 16.2509 29.5405C16.3454 30.375 17.0882 31.1759 17.866 31.2824C22.6035 31.9059 27.3958 31.9059 32.1346 31.2824C32.9118 31.1762 33.6546 30.375 33.7491 29.5405C34.0836 26.4833 34.0836 23.5177 33.7491 20.4594ZM23.4999 28.1767V21.8241L27.9999 25.0007L23.4999 28.1767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.607569fb9c2492b362a9fd89b4f12a59.svg";
export { ForwardRef as ReactComponent };